import { render, staticRenderFns } from "./EventViewBet.vue?vue&type=template&id=cffb5406"
import script from "./EventViewBet.vue?vue&type=script&lang=js"
export * from "./EventViewBet.vue?vue&type=script&lang=js"
import style0 from "./EventViewBet.vue?vue&type=style&index=0&id=cffb5406&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports